import clsx from 'clsx';
import { CalculatingSpinner } from 'components/UI';
import { FunctionComponent, ReactNode } from 'react';
import styles from './TotalResumeLine.module.css';

export interface TotalResumeLineProps {
    description: string;
    value: string;
    loading?: boolean;
    className?: string;
    descriptionClassName?: string;
    valueClassName?: string;
    action?: ReactNode;
}

export const TotalResumeLine: FunctionComponent<TotalResumeLineProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.leftContainer}>
                <span className={props.descriptionClassName ?? styles.text}>{props.description}</span>
            </div>
            <div className={styles.rightContainer}>
                {props.loading ? (
                    <CalculatingSpinner />
                ) : (
                    <span className={props.valueClassName ?? styles.text}>{props.value}</span>
                )}
                {props.action}
            </div>
        </div>
    );
};

export default TotalResumeLine;
